var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled/macro';
export var ModalContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  width: 300px;\n  border-radius: 10px;\n"], ["\n  background-color: ", ";\n  width: 300px;\n  border-radius: 10px;\n"])), function (props) { return props.theme.colors.light1; });
export var ModalContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 10px;\n  text-align: center;\n  display: flex;\n  padding: 60px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n"], ["\n  padding: 10px;\n  text-align: center;\n  display: flex;\n  padding: 60px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n"])));
export var ModalStyle = {
    overlay: {
        // position: 'fixed',
        padding: 0,
        backgroundColor: '#404040CC',
    },
    content: {
        background: 'transparent',
        border: 'none',
        padding: 0,
        top: '50px',
        right: 'initial',
        bottom: 'initial',
        left: 'calc(50% - 150px)',
    },
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Modal.js.map